import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_HOME_SHOWCASE } from '../store';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const { homeShowcase } = useAppData();
  const products = homeShowcase || DEF_HOME_SHOWCASE;

  return (
    <section className="product-range-section">
      <div className="product-range-container">
        <h2 className="product-range-title" data-aos="fade-up">Product Range - Film Galvanising Systems</h2>
        <p className="product-range-subtitle" data-aos="fade-up" data-aos-delay="80">World-class cathodic protection coatings trusted by engineers across India</p>

        <div className="product-list">
          {products.map((product, idx) => (
            <div key={product.id} className="product-list-item" data-aos="fade-up" data-aos-delay={idx * 80}>
              <div className="product-list-content">
                <h3 className="product-list-name">{product.name}</h3>
                <p className="product-list-subtitle">{product.subtitle}</p>
                {product.specs && product.specs.length > 0 && (
                  <ul className="product-spec-list">
                    {product.specs.map((spec, i) => (
                      <li key={i}>
                        <span className="spec-label-text">{spec.label}</span>
                        {' - '}
                        {spec.bold ? <strong>{spec.value}</strong> : <span>{spec.value}</span>}
                      </li>
                    ))}
                  </ul>
                )}
                <div className="product-buy-row">
                  <a href={`/product/${product.id}`} className="btn-buy-now">Buy now</a>
                </div>
              </div>
              <div className="product-list-image">
                <img src={product.image} alt={product.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
